<template>
  <!--
    name: 覃刚
    function: nhf管理
    date: 2021-03-09
 -->
  <div class="listContent operation_log_class">
    <a-form :form="form" class="headForm">
      <a-row :gutter="24">
        <a-col :span="4">
          <a-form-item
            label="配方"
          >
            <a-input v-decorator="['formulaKeyword']" @pressEnter="getList({current:1,pageSize:pagination.pageSize})" placeholder="请输入配方名称/代码" />
          </a-form-item>
        </a-col>

        <a-col :span="4">
          <a-form-item
            label="线路"
          >
            <a-select v-decorator="['lineId']" placeholder="选择线路">
              <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
                {{el.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="4">
          <a-form-item
            label="动物类型"
          >
            <animal-select @change="anmimlChange" :val="animal" />
          </a-form-item>
        </a-col>
        <a-col :span="4" class="submitBtnBox">
          <a-button type="primary" class="btnMar"  @click="getList({current:1,pageSize:pagination.pageSize})">
            查询
          </a-button>
          <a-button class="" @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <a-table :columns="columns" :data-source="list" ref="listRef" :scroll="{y,x: 820}" class="tableBox" :pagination="pagination">
      <template slot="formulaName" slot-scope="t,r">
        <a @click="showAddFunc(r)">{{ t }}</a>
      </template>
      <div slot="name8"  slot-scope="text,record">
        <a style="margin-right:10px" @click="showAddFunc(record)">查看</a>
        <a style="margin-right:10px" @click="showRestoreConfirm(record)">恢复</a>
        <!-- <a :disabled="!record.fileUrl" @click="e => scanPriceList(e,record)">报表</a> -->

        <!-- <a-dropdown v-if="record.version" style="width:90px">
          <a>报表</a>
          <a-menu slot="overlay" @click="e => scanPriceList(e,record)">
            <a-menu-item key="1">配方报表</a-menu-item>
            <a-menu-item key="2">生产报表</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> Button <a-icon type="down" /> </a-button>
        </a-dropdown>
        <a v-else disabled>报表</a> -->
      </div>
    </a-table>
    <!-- 查看 -->
    <a-modal
      title="查看配方"
      :visible="showAdd"
      :confirm-loading="confirmLoading"
      @ok="addSubmit"
      @cancel="showAddFunc"
      cancelText='关闭'
      :maskClosable='false'
      :footer='null'
      width='800px'
      class="scanBox"
      :destroyOnClose="true"
    >
      <FormulaAdd ref="add" :rowId="rowId" :factoryId="factoryId"/>
      <div class="btnFooter">
        <a-button @click="showAddFunc">
          关闭
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import FormulaAdd from './FormulaAdministration/FormulaAdd'
// import AnimalList from '@/components/Common/components/AnimalList'
// import FormulaEdit from './FormulaAdministration/FormulaEdit'
import moment from 'moment';
import AnimalSelect from "@/components/Nhf/Compound/select/AnimalSelect.vue";
export default {
  components:{
    AnimalSelect,
    FormulaAdd,
    // FormulaEdit
  },
  data(){
    return {
      factoryList: [],
      treeList: [],
      group: [],
      animal: [],
      lineList: [],
      factoryId: '',
      y: 500,
      rowId:'',
      typeList:[],
      typeList2: [],
      form: this.$form.createForm(this, { name: 'rawMaterialList' }),
      selectList:[],
      confirmLoading: false,
      showAdd: false,// 是否显示新增
      restoreRecord: {}, // 要恢复的记录
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      },
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      list:[],
      columns: [
        {
          title: '配方名称',
          dataIndex: 'formulaName',
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: 'formulaName' },
        },
        {
          title: '代码',
          dataIndex: 'formulaCode',
          ellipsis: true,
          width: 140,
        },
        {
          title: '动物类型',
          dataIndex: 'animalTypeName',
          ellipsis: true,
          width: 120,
        },
        {
          title: '客户名称',
          dataIndex: 'customName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '工厂名称',
          dataIndex: 'factoryName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '排序',
          dataIndex: 'sortNum',
          ellipsis: true,
          width: 80,
        },
        {
          title: '编辑用户',
          dataIndex: 'userName',
          width:90,
          ellipsis: true,
        },
        {
          title: '编辑时间',
          dataIndex: 'updateTime',
          width: 170,
          ellipsis: true,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 120,
          ellipsis: true,
        },
        // {
        //   title: '额外添加',
        //   dataIndex: 'xxx',
        //   width: 80,
        //   ellipsis: true,
        // },
        {
          title: '操作',
          dataIndex: 'name8',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'name8' },
        }
      ],
      rowSelection:{
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectList = selectedRows
        },
      },
      searchData: {},
      animalClear: 0
    }
  },
  created(){
    this.getTypeList2()
    // this.getTypeList()
    this.getTreeList()
  },
  mounted(){
    this.y = this.$refs.listRef.$el.offsetHeight - 116
  },
  watch: {
    group: {
      handler(){
        this.form.setFieldsValue({factoryIdList: []})
      },
      deep:true
    }
  },
  methods:{
    changeForm(data){
      this.searchData = {...this.searchData,...data}
    },
    anmimlChange(val) {
      this.animal = val;
      this.searchData.animalTypeCode = [...val].pop();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    groupChage(val){
      if(val && val.length){
        let deptId = val && val.length ? val[val.length - 1] : undefined
        let params = {current: 1,size: 1000,deptId}
        this.$http.get('/iot-factory/factory/selectFactoryInfoPage',{params}).then(res => {
        let {success,data} = res || {}
        if(success) {
          let {records} = data || {}
          this.factoryList = records || []
        }
      })
      }else{
        this.factoryList = []
      }
    },
    dealList(list=[]){
      list.map(el => {
        if(el.children && el.children.length > 0){
          this.dealList(el.children)
        }
        el.edit = false
        el.scopedSlots = {title: 'custom'}
      })
      return list
    },
    getTreeList(){
      this.$http.get('/iot-system/dept/tree').then(res => {
        let {success,data=[]} = res || {}
        if(success) {
          this.treeList = this.dealList(JSON.parse(JSON.stringify(data)))
          // this.cache = this.dealList(JSON.parse(JSON.stringify(data)))
        }
      })
    },
    getTypeList2(){
      let params = {
        current: 1,
        size: 10000
      }
      this.$http.get(`/nhf-core-data/line/list`,{params}).then(res => {
        let { success, data } = res
        if (success) {
          let {records} = data || {}
          records&&records.map(el => {
            el.value = el.id
            el.label = el.name
            return
          })
          this.typeList2 = records || []
          this.getLineList()
        }
      })
    },
    getLineList(){
      let staffId = window.localStorage.getItem('staffId')
      if(!staffId) return
      this.$http.get(`/iot-factory/factorystaffauth/getAnimalIdsInfoByStaffId?StaffId=${staffId}&type=0`).then(data => {
        // let {success,data} = res || {}
        if(data && data.length > 0){
          data = data.sort((a,b) => a - b)
          let lineList = []
          this.typeList2 && this.typeList2.forEach(el => {
            if(data.includes(el.id)) lineList.push(el)
          })
          this.lineList = lineList
          this.getList()
          // this.form.setFieldsValue({lineId: this.lineList[0].id || ''})
          // setTimeout(() => {
          //   this.getList()
          // }, 0);
        }
      })
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        this.getTypeList(targetOption.id,targetOption) || []
      }, 0);
    },
    getTypeList(parentId='0',record,flag){
      this.$http.get(`/nhf-core-data/animal/listByParentId?parentId=${parentId}`).then(res => {
        let {success,data=[]} = res;
        if(success){
          data && data.map(el => {
            el.value = el.id
            el.label = el.name
            el.isLeaf = !el.hasChildren
            return el
          })
          if(record){
            if(data.length){
              record.children = data
            }else {
              record.isLeaf = true
            }
            this.typeList = [...this.typeList];
          }else{
            this.typeList = data
          }
          if(flag) this.getLineList()
          if(parentId === '0'){
            this.getTypeList(this.typeList[0].id,this.typeList[0],true)
          }
        }else{
          this.typeList = []
        }
      })
    },
    resetFields(){
      this.group = []
      this.factoryList = []
      this.animalClear++
      this.animal = [];
      this.searchData.animalTypeCode = undefined
      this.form.setFieldsValue({'formulaKeyword': '','factoryKeyword': '','updateUserName': '',
        'updateTime': [],factoryIdList: [],lineId: undefined})
    },
    getList(pagination){
      this.selectList = []
      let {current=1,pageSize=20} = pagination || this.pagination
      let factoryId = window.localStorage.getItem('factoryId');
      this.form.validateFields((err, data) => {
        let {updateTime,factoryIdList=[],...newdata} = data
        if(this.group.length > 0 && factoryIdList.length === 0) {
          this.$message.warning('请选择工厂')
          return
        }
        let editStartTime = updateTime && updateTime[0] ? moment(updateTime[0]).format('YYYY-MM-DD 00:00:00') : undefined
        let editEndTime = updateTime && updateTime[1] ? moment(updateTime[1]).format('YYYY-MM-DD 23:59:59') : undefined
        let params = {
          ...this.searchData,
          factoryIdList,
          ...newdata,
          formulaType: 4,
          factoryId:factoryId,
          query: {current,size:pageSize},
          // current,size:pageSize,
          editStartTime,editEndTime,
          // animalTypeCode: typeArr.length ? typeArr[typeArr.length - 1] : undefined,

        }
        this.$http.post('/nhf-custom/archivedCustomFormula/pageArchivedCustomFormulaByCond',params).then(res => {
        // this.$http.post('/nhf-app/formulaNhf/formulaNhfCondPage',params).then(res => {
          let {success,data} = res;
          if(success){
            let {records,current=1,total=0} = data;
            this.pagination.current = current
            this.pagination.total = total
            this.list = records || []
          }else{
            this.$message.error('查询失败')
          }
          window.localStorage.setItem('fileUrl','')
        })
      })
    },
    deleteData(){
      this.$confirm({
        title: '提示',
        content: '确认将选中的原料删除吗？',
        cancelText:'取消',
        okText:'确定',
        onOk() {
        },
        onCancel() {
        },
      });

    },
    scanPriceList({key:formulaReportType},record){
    // 查看价格
      // this.$router.push(`/print/Printing?name=报表打印&id=${record.id}`)
      let routeData = this.$router.resolve({
        path: `/print/Printing?name=${record.updateUserName}的${record.formulaName}配方&id=${record.id}&formulaReportType=${formulaReportType}`
      });
      // window.localStorage.setItem('fileUrl',record.fileUrl)
      window.open(routeData.href, "_blank");
    },
    addSubmit(){
      // 新增提交
      // this.$refs['add'].form.validateFields((err, values) => {
      // })
      this.showAddFunc()
    },
    showAddFunc(record){
      // // 新增显示或关闭
      // if(record && record.id){
      //   this.rowId = record.id
      //   this.factoryId = record.factoryId
      // }
      // this.$nextTick(() => {
      //   this.showAdd = !this.showAdd
      // })

      this.$router.push(`/archive-data/customized-formula/archive-data-customized-compound-detail?name=定制料饲料归档详情&id=${record.id}&factoryId=${record.factoryId}`)
    },
    editSubmit(){
      // 编辑提交
      // this.$refs['edit'].form.validateFields((err, values) => {
      // })
      this.showEditFunc()
    },
    showEditFunc(type){
      // 编辑显示或关闭
      if(type === 'edtiBtn'){
        if(this.selectList.length > 1){
          this.$message.warning('编辑只能选中一条数据')
        }else if(this.selectList.length === 0){
          this.$message.warning('请选中需要编辑的数据')
        }else{
          this.showEdit = !this.showEdit
        }
      }else{
        this.showEdit = !this.showEdit
      }
    },
    // 显示恢复确认框
    showRestoreConfirm(record) {
      if (record && record.id) {
        this.restoreRecord = record;
        this.$confirm({
          title: '产品数据恢复',
          content: `确认将产品《${record.formulaName}》的数据进行恢复吗？`,
          cancelText: '取消',
          okText: '确定',
          onOk: () => {
            return this.handleRestore();
          },
          onCancel: () => {
            this.restoreRecord = {};
          }
        });
      }
    },
    // 处理恢复操作
    handleRestore() {
      const formulaId = this.restoreRecord.id;

      // 调用恢复接口
      return this.$http.post('/nhf-custom/archivedCustomFormula/restoreArchivedCustomFormula', null, {
        params: { formulaId }
      }).then(res => {
        if (res.success) {
          this.$message.success('配方数据恢复成功');
          this.getList(); // 刷新列表
        } else {
          this.$message.error(res.message || '恢复失败');
        }
        this.restoreRecord = {};
        return res;
      }).catch(err => {
        this.$message.error('恢复失败: ' + (err.message || '网络错误'));
        this.restoreRecord = {};
      });
    }
  }
}
</script>
<style lang="scss">
.scanBox{
  .ant-modal-body{
    padding: 0 10px 0 10px;
  }
.operation_log_class .ant-form-item-label {
    width: 62px;
  }
}
</style>
<style lang="scss" scoped>
.btnFooter{
  border-top: 1px solid #e8e8e8;
  height: 50px;
  line-height: 50px;
  text-align: right;
}
.listContent{
  .tableBox{
    height: calc(100% - 120px);
  }
}
</style>

<style lang="scss">
  .ant-select-sm .ant-select-selection--multiple{
    overflow-y: auto;
  }
</style>
